<mat-radio-group class="radio-group" (change)="eventFired($event.value)">
    <mat-radio-button class="radio-button" [checked]="option.checked"
    *ngFor="let option of options" [value]="option">
      <span class="radio-label">{{option.desc}}</span>  
    </mat-radio-button>
</mat-radio-group>
